import {useListView} from '../../core/ListViewProvider'
import {OrdersListToolbar} from './SuggestionsListToolbar'
import {UsersListGrouping} from './SuggestionsListGrouping'

const SuggestionsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {/* <OrdersListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <UsersListGrouping /> : <OrdersListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {SuggestionsListHeader}
